import AccountSummary from './AccountSummary';
import { withI18n } from 'react-i18next';
export default withI18n()(AccountSummary);
